const Meses = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export const findMonthByName = (monthName) => {
  const monthNumber = Meses.findIndex((month) => month === monthName);

  console.log('monthNumber', monthNumber);
  return monthNumber;
};

export const findMonthByIndex = (index) => {
  return Meses[index];
};
